import React, { FunctionComponent } from 'react';
import Media from 'react-media';
import { Icon } from '@iag-packages/chroma-react/lib/components';

import { Heading, Accordion, AccordionItem, Text } from 'components/chroma';
import { HomeFullPageProps } from 'scenes/home/types';
import { SCREEN } from 'scenes/common/types/screen';

import PropertySummary from './Summary/PropertyDetails';
import CoverDetailsSummary from './Summary/CoverDetails';
import { PolicyDetailsSummary } from './Summary/PolicyDetails';

export const OverallDetailsSummary: FunctionComponent<Pick<
  HomeFullPageProps,
  | 'funnelState'
  | 'referenceData'
  | 'onEditQuoteDetails'
  | 'onEditCoverDetails'
  | 'onEditPolicyDetails'
>> = ({
  funnelState,
  referenceData,
  onEditQuoteDetails,
  onEditCoverDetails,
  onEditPolicyDetails,
}) => (
  <Media query={{ minWidth: SCREEN.MEDIUM }}>
    {(shouldExpandAccordion) => {
      const initialActiveAccordionItems = shouldExpandAccordion
        ? [0, 1, 2]
        : [];

      return (
        <>
          <Heading size={4}>Overall details</Heading>
          <Text>
            Click on the&nbsp;
            <Icon name="pen" color="primary" ariaLabel="edit-icon" />
            &nbsp;to go back to edit your information
          </Text>
          <Accordion id="overallDetails" className="heading-label">
            <AccordionItem
              id="propertyDetailsSummary"
              label={{ text: 'Property details' }}
              activeItems={initialActiveAccordionItems}
              content={{
                component: (
                  <PropertySummary
                    funnelState={funnelState}
                    referenceData={referenceData}
                    onEditQuoteDetails={onEditQuoteDetails}
                    onEditPolicyDetails={onEditPolicyDetails}
                  />
                ),
              }}
            />
            <AccordionItem
              id="coverDetailsSummary"
              label={{ text: 'Policy coverage' }}
              activeItems={initialActiveAccordionItems}
              content={{
                component: (
                  <CoverDetailsSummary
                    funnelState={funnelState}
                    onEditQuoteDetails={onEditQuoteDetails}
                    onEditCoverDetails={onEditCoverDetails}
                    referenceData={referenceData}
                  />
                ),
              }}
            />
            <AccordionItem
              id="policyDetailsSummary"
              label={{ text: 'Policy details' }}
              activeItems={initialActiveAccordionItems}
              content={{
                component: (
                  <PolicyDetailsSummary
                    funnelState={funnelState}
                    onEditQuoteDetails={onEditQuoteDetails}
                    onEditPolicyDetails={onEditPolicyDetails}
                  />
                ),
              }}
            />
          </Accordion>
        </>
      );
    }}
  </Media>
);

export default OverallDetailsSummary;
